import * as echarts from 'echarts';
import React, {Component} from 'react';

import {connect} from "react-redux";
class ManpowerChart extends Component
{


  componentDidMount()
  {

this.initChart2();

  }

  render()
  {
    return (

      <div className="manpower-chart">
        <div className="manpower-chart-content" style={{height: 300}}>
          <div id="desighcomments-chart" style={{width: '100%', height: '100%'}}></div>
        </div>
      </div>
    );
  }


  initChart2()
  {

    var chartDom = document.getElementById('desighcomments-chart');
    var myChart = echarts.init(chartDom);
    var option;

    option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      legend: {
        data: ['Total', 'Completed', 'Completed rate']
      },
      xAxis: [
        {
          type: 'category',
          data: ['Leed Consultant', 'PCM+ICC+WH SC', '3rd party authority' ],
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Total',
          min: 0,
          max: 700,
          interval: 100,
          axisLabel: {
            formatter: '{value}'
          }
        },
        {
          type: 'value',
          name: 'Completed rate',
          min: 99,
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        }
      ],
      series: [
        {
          name: 'Total',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + '';
            }
          },
          data: [
            9,578,6
          ]
        },
        {
          name: 'Completed',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + '';
            }
          },
          data: [
            9,577,6
          ]
        },
        {
          name: 'Completed rate',
          type: 'line',
          yAxisIndex: 1,
          tooltip: {
            valueFormatter: function (value) {
              return value + '%';
            }
          },
          data: [100,577/578*100,100]
        }
      ]
    };

    option && myChart.setOption(option);
  }
}


const mapStateToProps = (state) => {
  // console.log("loginPage/mapStateToProps",state.customers1.customerList);
  return {vo: state.customers.openCustomer};
};
// export default LoginPage;
export default connect(
  mapStateToProps
)(ManpowerChart);